// 定义默认的SQL注入过滤正则表达式
const DEFAULT_SANITIZE_REGEX = /['";\\\-<>()=]/g;

// 指令核心逻辑
const SanitizeInputDirective = {
  bind(el, binding) {
    // 1. 获取配置参数
    const regex = binding.value || DEFAULT_SANITIZE_REGEX;
    const eventType = binding.arg || "input"; // 默认监听input事件

    // 2. 定义过滤函数
    const sanitize = originalValue => {
      return originalValue.replace(regex, "");
    };

    // 3. 事件处理器
    const handler = e => {
      const sanitized = sanitize(e.target.value);
      if (sanitized !== e.target.value) {
        e.target.value = sanitized;
        el.dispatchEvent(new Event(eventType)); // 触发数据更新
        showToastIfNeeded(binding.modifiers); // 可选提示
      }
    };

    // 4. 注册事件监听
    el.addEventListener(eventType, handler);

    // 5. 保存引用以便解绑
    el._sanitizeHandler = handler;
  },

  unbind(el) {
    // 移除事件监听防止内存泄漏
    el.removeEventListener("input", el._sanitizeHandler);
  }
};

// 可选：显示过滤提示
function showToastIfNeeded(modifiers) {
  if (modifiers.notify) {
    console.log("检测到危险字符并已自动移除");
    // 实际项目中可替换为UI框架的Toast提示
  }
}

// 导出安装方法（兼容Vue插件形式）
export default {
  install(Vue, options = {}) {
    Vue.directive("sanitize", {
      ...SanitizeInputDirective,
      // 允许全局覆盖默认正则
      bind(el, binding) {
        const globalRegex = options.regex || DEFAULT_SANITIZE_REGEX;
        const localBinding = {
          ...binding,
          value: binding.value || globalRegex
        };
        SanitizeInputDirective.bind(el, localBinding);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/directives/sanitizeInput.js